/**
 * @author liqiuqi
 * @date 2022 2022/11/14 16:08
 */
import { config } from "../utils/config";
import { omniAxios } from "../utils/axios";

export function restCaptchaGet(params) {
  return omniAxios({
    url: config.restCaptchaGetPath,
    method: "post",
    isTwoPointZeroInterfaceApi: true,
    params,
  });
}

export function restCaptchaCheck(params) {
  return omniAxios({
    url: config.restCaptchaCheckPath,
    method: "post",
    isTwoPointZeroInterfaceApi: true,
    params,
  });
}
export function restCaptchaNoLoginCheck(params) {
  return omniAxios({
    url: config.restCaptchaNoLoginCheckPath,
    method: "post",
    isTwoPointZeroInterfaceApi: true,
    params,
  });
}
